import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAppDispatch } from "@/core/root-reducer"
import unitStore from "../entities/unit/model/unit.store"
import NavFocus from "@/nav/nav.focus"
import RisksUnitHome from "../entities/unit/ui/RisksUnitHome"
import { useResetRisksSort } from "../hooks/useResetRisksSort"

export default function RisksUnitRoute() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  useResetRisksSort()

  useEffect(() => {
    if (id) {
      dispatch(unitStore.actions.clearSelected())
      dispatch(unitStore.actions.select(id))
    }
  }, [])

  return (
    <NavFocus onBack={() => navigate("/risks/units")} text="Unités de travail">
      <RisksUnitHome />
    </NavFocus>
  )
}
